module.exports = __webpack_public_path__ + "static/img/loader.16e6437.gif";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/loader.gif
// module id = 215
// module chunks = 0